import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IEventsService } from './ievents.service';
import { EventSearchParams } from '../search/event-search-params.model';
import { EventNewParams } from '../new/event-new-params.model';
import { EventEdit } from './event-edit.model';
import { EventRead } from './event-read.model';
import { EventCopy } from './event-copy.model';
import { ApiService, PagedSearch, PagedResult } from '../../shared/index'; //app/shared/index barrel;
import { NameValueNumber } from '../../shared/model/name-value-number.model';
import { UserService } from '../../users/shared/user.service';
import { UtilService } from '../../shared/util/util.service';
import { ConfigService } from '../../config/shared/config.service';
import { AppContext } from '../../config/shared/app-context.model';

//import moment from 'moment-es6';
import { MomentService } from '../../shared/moment/moment.service';
import { NavigationService } from '../../shared/navigation/navigation.service';

@Injectable()
export class EventsService {
  // implements IEventsService {

  private _momentService: MomentService;

  public _apiService: ApiService;
  public _utilService: UtilService;
  public _userService: UserService;
  public _navigationService: NavigationService;

  public constructor(
    apiService: ApiService,
    userService: UserService,
    utilService: UtilService,
    public _configService: ConfigService,
    momentService: MomentService,
    navigationService: NavigationService
  ) {
    this._momentService = momentService;
    this._apiService = apiService;
    this._userService = userService;
    this._utilService = utilService;
    this._navigationService = navigationService;
  }

  public getUpcomingEvents = (): Promise<any> => {
    let url: string =
      '/Events?UpcomingEventsOnly=true&SearchDateBegin=' +
      encodeURIComponent('1/1/1900') +
      '&SearchDateEnd=' +
      encodeURIComponent('12/31/2999');
    return this._apiService.get(url);
  };

  public getNextFiveOrgEvents(): Promise<PagedResult> {
    let startDate = new Date();
    let endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 6);

    let url: string =
      '/Events?UpcomingEventsOnly=true&SearchDateBegin=' +
      encodeURIComponent(startDate.toDateString()) +
      '&SearchDateEnd=' +
      encodeURIComponent(endDate.toDateString()) +
      '&PageSize=5&OrganizationEvent=True';
    return this._apiService.get(url);
  }

  public getUpcomingOrgEventsForSixMonths(): Promise<PagedResult> {
    let startDate = new Date();
    let endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 6);

    let url: string =
      '/Events?UpcomingEventsOnly=true&SearchDateBegin=' +
      encodeURIComponent(startDate.toDateString()) +
      '&SearchDateEnd=' +
      encodeURIComponent(endDate.toDateString()) +
      '&PageSize=99999&OrganizationEvent=True';
    return this._apiService.get(url);
  }

  public getUpcomingOrgEventsForSixMonthsPaged(pageSize: number, pageNum: number): Promise<PagedResult> {
    let startDate = new Date();
    let endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 6);

    let url: string =
      '/Events?UpcomingEventsOnly=true&SearchDateBegin=' +
      encodeURIComponent(startDate.toDateString()) +
      '&SearchDateEnd=' +
      encodeURIComponent(endDate.toDateString()) +
      `&PageSize=${pageSize}&PageNumber=${pageNum}&OrganizationEvent=True`;
    return this._apiService.get(url);
  }

  //public getDashBoardEvents(): Observable<PagedResult> {

  //    let url: string = "/Events?UpcomingEventsOnly=true&SearchDateBegin=" + encodeURIComponent("1/1/1900") + "&SearchDateEnd=" + encodeURIComponent("12/31/2999");
  //    return this._apiService.getObservable(url);
  //}

  public searchEvents = (pagedSearch: EventSearchParams): Promise<any> => {
    let eventId = pagedSearch.EventId;
    if (!eventId && /^\d+$/.test(pagedSearch.Keyword)) {
      eventId = parseInt(pagedSearch.Keyword);
    }
    let params: any = {
      PageNumber: pagedSearch.PageNumber,
      PageSize: pagedSearch.PageSize,
      OrderBy: pagedSearch.OrderBy,
      Keyword: pagedSearch.Keyword,
      EventId: pagedSearch.EventId,
      OrganizationEvent: pagedSearch.OrganizationEvent,
      CommunityEvent: pagedSearch.CommunityEvent,
      MembersOnlyEvent: pagedSearch.MembersOnlyEvent,
      InternalEvent: pagedSearch.InternalEvent,
      EventsWithPendingRegistrationsOnly: pagedSearch.EventsWithPendingRegistrationsOnly,
      SearchDateBegin: pagedSearch.SearchDateBegin,
      SearchDateEnd: pagedSearch.SearchDateEnd,
      EventType: pagedSearch.EventType,
    };
    let url: string = '/Events';
    return this._apiService.getPaged(url, params);
  };

  /**
   * export registrations. gets back url to export
   * @param pagedSearch
   */
  public getEventsExport(pagedSearch: EventSearchParams): Promise<string> {
    let eventId = pagedSearch.EventId;
    if (!eventId && /^\d+$/.test(pagedSearch.Keyword)) {
      eventId = parseInt(pagedSearch.Keyword);
    }
    let params: any = {
      PageNumber: pagedSearch.PageNumber,
      PageSize: pagedSearch.PageSize,
      OrderBy: pagedSearch.OrderBy,
      Keyword: pagedSearch.Keyword,
      EventId: pagedSearch.EventId,
      OrganizationEvent: pagedSearch.OrganizationEvent,
      CommunityEvent: pagedSearch.CommunityEvent,
      MembersOnlyEvent: pagedSearch.MembersOnlyEvent,
      InternalEvent: pagedSearch.InternalEvent,
      EventsWithPendingRegistrationsOnly: pagedSearch.EventsWithPendingRegistrationsOnly,
      SearchDateBegin: [
        pagedSearch.SearchDateBegin.getMonth() + 1,
        pagedSearch.SearchDateBegin.getDate(),
        pagedSearch.SearchDateBegin.getFullYear(),
      ].join('/'),
      SearchDateEnd: [
        pagedSearch.SearchDateEnd.getMonth() + 1,
        pagedSearch.SearchDateEnd.getDate(),
        pagedSearch.SearchDateEnd.getFullYear(),
      ].join('/'),
      EventType: pagedSearch.EventType,
    };

    // convert to string query
    let queryParams: string = Object.keys(params)
      .filter((k) => params[k] != null)
      .map((k: string) => k + '=' + encodeURIComponent(params[k]))
      .join('&');

    let url: string = '/Events/CSV?' + queryParams;
    return this._apiService.get(url);
  }

  public quickSearchEvents = (pagedSearch: EventSearchParams): Promise<any> => {
    let params: any = {
      PageNumber: pagedSearch.PageNumber,
      PageSize: pagedSearch.PageSize,
      OrderBy: pagedSearch.OrderBy,
      Keyword: pagedSearch.Keyword,
      SearchDateBegin: pagedSearch.SearchDateBegin,
      SearchDateEnd: pagedSearch.SearchDateEnd,
      EventId: pagedSearch.EventId,
    };

    // set date defaults
    if (!params.SearchDateBegin) {
      params.SearchDateBegin = this._momentService.getMomentByDate(new Date()).format('YYYY-MM-DD');
    }
    if (!params.SearchDateEnd) {
      // give a 12 month date range
      params.SearchDateEnd = this._momentService.getMomentByDate(new Date(params.SearchDateBegin)).add(12, 'months').format('YYYY-MM-DD');
    }
    let url: string = '/Events';
    return this._apiService.getPaged(url, params);
  };

  public getUpcomingEventsPaged = (pagedSearch: EventSearchParams): Promise<any> => {
    let params: any = {
      PageNumber: pagedSearch.PageNumber,
      PageSize: pagedSearch.PageSize,
      OrderBy: pagedSearch.OrderBy,
      UpcomingEventsOnly: true,
      Keyword: pagedSearch.Keyword,
      SearchDateBegin: pagedSearch.SearchDateBegin,
      SearchDateEnd: pagedSearch.SearchDateEnd,
    };

    // set date defaults
    if (!params.SearchDateBegin) {
      params.SearchDateBegin = this._momentService.getMomentByDate(new Date()).format('YYYY-MM-DD');
    }
    if (!params.SearchDateEnd) {
      // give a 12 month date range
      params.SearchDateEnd = this._momentService.getMomentByDate(new Date(params.SearchDateBegin)).add(12, 'months').format('YYYY-MM-DD');
    }
    let url: string = '/Events'; //?UpcomingEventsOnly=true&SearchDateBegin=" + encodeURIComponent("1/1/1900") + "&SearchDateEnd=" + encodeURIComponent("12/31/2999");
    return this._apiService.getPaged(url, params);
  };

  public getRecentlyViewed = (pagedSearch: EventSearchParams): Promise<any> => {
    let params: any = {
      PageNumber: pagedSearch.PageNumber,
      PageSize: pagedSearch.PageSize,
      OrderBy: pagedSearch.OrderBy,
      UpcomingEventsOnly: true,
      Keyword: pagedSearch.Keyword,
      SearchDateBegin: '2010-1-1',
      SearchDateEnd: '2050-1-1',
    };
    let url: string = '/Events/RecentlyViewed';
    return this._apiService.getPaged(url, params);
  };

  public createEvent = (eventNewParams: EventNewParams): Promise<any> => {
    //set the spurceutcoffset for this client
    eventNewParams.SourceUtcOffSetMinutes = this._utilService.getCurrentUtcOffSetMinutes();

    let url: string = '/Events'; //?UpcomingEventsOnly=true&SearchDateBegin=" + encodeURIComponent("1/1/1900") + "&SearchDateEnd=" + encodeURIComponent("12/31/2999");
    return this._apiService.post(url, eventNewParams);
  };

  public delete = (eventId: number): Promise<void> => {
    return this._apiService.delete(`/Event/${eventId}`);
  };

  public getEventEdit = (eventId: number): Promise<EventEdit> => {
    let url: string = '/Event/' + eventId.toString();
    return this._apiService.get(url).then((event: EventEdit) => {
      // fix urls in event if there's an event
      if (event) {
        var fixPromies: Array<Promise<string>> = [];
        fixPromies.push(this.setUrlsToFullPath(event.Descr).then((fixedDescr) => (event.Descr = fixedDescr)));
        fixPromies.push(
          this.setUrlsToFullPath(event.ConfirmationMessage).then(
            (fixedConfirmationMessage) => (event.ConfirmationMessage = fixedConfirmationMessage)
          )
        );

        // make sure the public registraton end date has a value
        if (!event.PublicRegistrationEndDateUtc || this._momentService.getMomentByDate(event.PublicRegistrationEndDateUtc).year() <= 1900) {
          event.UsePublicRegistrationEndDate = false;
          event.PublicRegistrationEndDateUtc = null;
        } else {
          event['UsePublicRegistrationEndDate'] = true;
        }

        return Promise.all(fixPromies).then(() => event);
      } else {
        return event;
      }
    });
  };

  private getEventReadApiGetUrl = (eventId: number): string => {
    let url: string = '/Event/' + eventId.toString();
    return url;
  };

  public getEventRead = (eventId: number): Promise<EventRead> => {
    let url: string = this.getEventReadApiGetUrl(eventId);
    return this._apiService.get(url);
  };

  public deleteEventReadCache = (eventId: number): void => {
    let url: string = this.getEventReadApiGetUrl(eventId);
    this._apiService.deleteCache(url);
  };

  public copyEvent = (eventId: number, data: EventCopy): Promise<number> => {
    let url: string = '/Event/' + eventId.toString() + '/Copy';
    return this._apiService.post(url, data);
  };

  public updateEvent = (eventId: number, data: EventEdit): Promise<void> => {
    //set the spurceutcoffset for this client
    data.SourceUtcOffSetMinutes = this._utilService.getCurrentUtcOffSetMinutes();

    // this gets set to current date by default. make it "nothing" to match what the user expects.
    if (!data.UsePublicRegistrationEndDate) data.PublicRegistrationEndDateUtc = new Date('1/1/1900');

    let url: string = '/Event/' + eventId.toString();
    return this._apiService.put(url, data);
  };

  /**
   * returns SignUpsAndAttendence report url to the legacy webclient with the appropriate web client secure domain and legacy token
   * @param eventId
   */
  public getSignUpsAndAttendenceReportUrl(eventId: number): Promise<string> {
    return this._userService.getCurrentUserLegacyToken().then((token: string) => {
      let url =
        this._navigationService.getLegacyDomain() +
        '/external/wcpages/v12/webclient/report/report.aspx?reportname=private_Events_EventsSignUpsAndAttendence&EventId=' +
        eventId.toString() +
        '&token=' +
        token;

      return url;
    });
  }

  /**
   * returns name badge report url to the legacy webclient with the appropriate web client secure domain and legacy token
   * @param eventId
   */
  public getNameBadgeReportUrl(eventId: number): Promise<string> {
    return this._userService.getCurrentUserLegacyToken().then((token: string) => {
      let url =
        this._navigationService.getLegacyDomain() +
        '/external/wcpages/v12/webclient/report/report.aspx?reportname=private_Events_NameBadge_Avery5383&recordselection=%7bEventList.EventID%7d+in+%5b' +
        eventId.toString() +
        '%5d' +
        '&token=' +
        token;

      return url;
    });
  }

  /**
   * helper to change image paths to urls
   * @param value
   */
  public setUrlsToFullPath(value: string): Promise<string> {
    if (value == null) return Promise.resolve(value);

    return this._configService.getAppContext().then((data: AppContext) => {
      value = this._utilService.replaceAll(value, "src='/", "src='" + data.WebRootSecure + '/');
      value = this._utilService.replaceAll(value, 'src="/', 'src="' + data.WebRootSecure + '/');
      return value;
    });
  }

  public getConfirmationMessagePreview = (eventId: number): Promise<string> => {
    let url: string = 'Event/' + eventId.toString() + '/ConfirmationMessage/Preview';
    return this._apiService.get(url);
  };
}
